import * as TK from 'components/post/AllReactionsDialog/translations/constants';
import { Translations } from 'translations/types';

export const allReactionsDialogEnUsLocale: Translations = {
  [TK.ALL_REACTIONS_DIALOG_TITLE]: 'All reactions',
  [TK.ALL_REACTIONS_DIALOG_ALL]: 'All',
};
